import React from "react";
import PropTypes from "prop-types";

// core components
import ListingTableHead from "components/Product/Table/ListingTableHead";

import {UserAgentUtils} from "../../../../../utils/useragent";

EnhancedTableHead.propTypes = {
    onSelectAllClick: PropTypes.func.isRequired,
};

function EnhancedTableHead({onSelectAllClick, isSelectAllChecked, isRetrievedFinished, tableHead, showCheckbox = true}) {
    return (
        <ListingTableHead
            rows={tableHead}
            mergeCheckboxInFirstCell={true}
            showCheckbox={!UserAgentUtils.isMobile() && showCheckbox}
            onSelectAllClick={onSelectAllClick}
            isSelectAllChecked={isSelectAllChecked}
            checkboxDisabled={!isRetrievedFinished}
        />
    );
}

export default EnhancedTableHead;
